<app-partners></app-partners>
<div class="footer-wrapper">
  <div class="container">
    <div class="footer-top">
      <div class="footer-top__logo">
        <a href="https://ligapadla.pl/">
          <img src="assets/images/LigaPadlaPl.png" alt="Liga Padla" />
        </a>
      </div>
      <div class="footer-top__links">
        <p-divider align="left" type="solid" class="footer-divider">
          <span>LIGAPADLA.PL</span>
        </p-divider>
        <app-menu-links [linksGroup]="linksGroup1"></app-menu-links>
      </div>
      <div class="footer-top__links">
        <p-divider align="left" type="solid" class="footer-divider">
          <span>PADEL</span>
        </p-divider>
        <app-menu-links [linksGroup]="linksGroup2"></app-menu-links>
      </div>
      <div class="footer-top__social">
        <p-divider align="left" type="solid" class="footer-divider">
          <span>BĄDŹ NA BIEŻĄCO</span>
        </p-divider>
        <app-menu-socials [socialsGroup]="socialsGroup"></app-menu-socials>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <div class="container">
      <div class="footer-bottom__wrapper">
        <div class="footer-bottom__links">
          <ul>
            <li>
              <a href="https://ligapadla.pl/polityka-prywatnosci" target="_blank">Polityka prywatności</a>
            </li>
            <li>
              <a href="https://ligapadla.pl/regulamin" target="_blank">Regulamin Usługi</a>
            </li>
            <li>
              <a href="https://ligapadla.pl/regulamin-rozgrywek" target="_blank">Regulamin Rozgrywek</a>
            </li>
          </ul>
        </div>
        <div class="footer-bottom__copyrights">
          <p class="mb-3">{{ currentYear }} © LigaPadla.pl - wszelkie prawa zastrzeżone</p>
          <p>LigaPadla.pl spółka z o.o.</p>
          <p>ul. Postępu 21C, 02-676 Warszawa</p>
          <p>NIP 5214084936, REGON 529610039</p>
          <p><a href="mailto:kontakt@ligapadla.pl">kontakt&#64;ligapadla.pl</a></p>
        </div>
      </div>
    </div>
  </div>
</div>
